export const REQUIRED_ERROR_MESSAGE = 'This field is required';
export const FORMAT_ERROR_MESSAGE = 'This value has wrong format';
export const IS_NUMERIC_ERROR_MESSAGE = 'This field is numeric';
export const ADDRESS_ERROR_MESSAGE = 'Address length should be more than ';
export const LENGTH_ERROR_MESSAGE = 'Value length should be exactly ';
export const MAX_LENGTH_ERROR_MESSAGE = 'The text entered exceeds the maximum length';
export const MIM_LENGTH_ERROR_MESSAGE = 'The text entered length should be more than ';
export const MIN_VALUE_ERROR_MESSAGE = 'Minimum value should equals or be more than ';
export const MAX_VALUE_ERROR_MESSAGE = 'The number entered exceeds the maximum value ';
export const DOUBLE_SEPARATOR_ERROR_MESSAGE = 'Entered value must be separated only by dot';